import styled from 'styled-components';

export const Container = styled.div`
  min-width: 100vw;
  min-height: 100vh;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  background-color: ${({ theme }) => theme.colors.background};
  transition: 0.2s;
`;

export const Text = styled.h1`
  font-size: 26px;
  font-weight: lighter;
  color: ${({ theme }) => theme.colors.textBackground};
`;
